angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "JOIN": {
    "WRONG_EMAIL_PASSWORD": "Wrong email or password"
  }
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/modules/join/join.json
// module id = 542
// module chunks = 24